// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ufMy{list-style:none;overflow-x:auto}._2OSCV{margin-bottom:1rem;font-size:18px;font-weight:500;line-height:25px;font-family:var(--heading-font);letter-spacing:.5px}.Yv2XN{color:#0373f9;cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.Yv2XN path[fill]{fill:#0373f9}.Yv2XN ._27jVP{margin-left:.5rem;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}._1LMyb{padding-bottom:2rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_1ufMy",
	"title": "_2OSCV",
	"showMore": "Yv2XN",
	"icon": "_27jVP",
	"material": "_1LMyb"
};
module.exports = exports;
